export default __webpack_public_path__ + "static/media/finance.8dc73dd7.svg";